// @ vendors
import { connect } from 'react-redux';

const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ components
const { ContractView } = require('./contractView');
import NotFoundView from 'routes/notFoundView/notFoundView';

// @constants
const { REDIRECT_URL } = require('constants/index');
const migratedContracts = {
  'at-home-abroad': '/myprofile/hire/card/at-home-abroad',
  'e-card': '/myprofile/hire/card/e-card',
  'open-debit': '/myprofile/hire/card/open-debit',
  'open-young': '/myprofile/hire/card/open-young',
  'visa-open': '/myprofile/hire/card/open-credit',
  'diamond-pack': '/myprofile/hire/card/diamond-pack',
  'premium-pack': '/myprofile/hire/card/premium-pack',
  'mini-card': '/myprofile/hire/card/minicard',
  'via-t': '/myprofile/hire/card/via-t',
};
// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { NOT_ALLOWED_CONTRACT_URLS_COUNTRIES } from 'constants/flagBasedFeatures';
import { isAContractThatNeedsHydration } from './isAContractThatNeedsHydration';

class ContractViewWrapper extends React.Component {
  constructor(props) {
    super(props);
    const {
        history,
        match: { params: { contractIndex, redirect } },
      immDeposits,
    } = props;


    let migratedContract = false;
    // We redirect if the hiring process has been migrated to the new hiring flow outside ContractView
    if (Object.keys(migratedContracts).includes(contractIndex)) {
      let newUrl = migratedContracts[contractIndex];
      migratedContract = true;
      if (redirect === REDIRECT_URL) {
        newUrl += `/${redirect}`;
      }
        history.push(newUrl);
    }
    const retentionRequestedDeposits = immDeposits.get('retentionRequestedDeposits').toJS();
    const extraContractData = retentionRequestedDeposits[contractIndex];

    if (!extraContractData && isAContractThatNeedsHydration(contractIndex)) {
        history.push('/myprofile/deposits');
    }

    this.state = {
      migratedContract,
      extraContractData
    };
  }

  render() {
    const { flagBasedFeatures, match: { params: { contractIndex } }, contractWizard, history } = this.props;
    const featureToggingCheck = NOT_ALLOWED_CONTRACT_URLS_COUNTRIES[contractIndex];
    const { migratedContract, extraContractData } = this.state;

    if (featureToggingCheck && !flagBasedFeatures.get(featureToggingCheck)) {
      return <NotFoundView notFoundViewPrivate={true} />;
    } else if (!contractWizard.get('fromRenewalOrTransferToken') && ['deposittransfer'].includes(contractIndex)){
      return <NotFoundView notFoundViewPrivate={true} />;
    } else if(!contractWizard.get('fromRenewalOrTransferToken') && ['depositrenewal'].includes(contractIndex)) {
      history.push('/myprofile/deposits');
    }
    else if ((!featureToggingCheck || featureToggingCheck && flagBasedFeatures.get(featureToggingCheck)) && !migratedContract) {
      return <ContractView {...this.props} key={contractIndex} extraContractData={extraContractData} />;
    }
    return null;
  }
}

ContractViewWrapper.propTypes = {
    history: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    immDeposits: PropTypes.object.isRequired,
    contractWizard: PropTypes.object.isRequired,
};

module.exports = withRouter(connect(
  state => ({
    contractWizard: state.contracts,
    immDeposits: state.deposits,
  }),
)(withFeatureToggling(ContractViewWrapper)));
